import { useLaunchDarklyStatus } from "@assetwatch/auth";
import { FullPageLoading } from "@assetwatch/ui";
import type { ReactNode } from "react";
import { useFeatureFlags } from "./LaunchDarkly/useFeatureFlags";
import { WorkAccessDenied } from "./WorkAccessDenied";

export function AppFeatureGate({ children }: { children: ReactNode }) {
  const { isReady } = useLaunchDarklyStatus();
  const flags = useFeatureFlags();

  if (!isReady) {
    return <FullPageLoading />;
  }

  if (!flags.workEnabled) {
    return <WorkAccessDenied />;
  }

  return <>{children}</>;
}
